import React, { useEffect, useRef, useState } from 'react';
import { useForm } from "react-hook-form";
import { AiFillDelete, AiOutlineClose, AiOutlineDelete, AiOutlineFileExcel, AiOutlineFilePdf, AiOutlineFileWord, AiOutlinePlus } from "react-icons/ai";
import { BsFillFileEarmarkPdfFill } from "react-icons/bs";
import { FcFolder } from "react-icons/fc";
import { FiCornerDownRight } from "react-icons/fi";
import { ToastContainer } from 'react-toastify';
import swal from 'sweetalert';
import HeaderDashboard from '../../Components/DashboardComponent/headerdashboard/HeaderDashboard';
import Sidebar from '../../Components/DashboardComponent/sidebar/Sidebar';
import HttpHelper from '../../service/httpService';
import DashboardWrapper from './DashboardWrapper';
import { hasAddPermission, hasDeletePermission, hasEditPermission, hasReadPermission, initilizeUserInfo } from "../../service/userService";

const SecurityObjectName = 'Website.DocumentsView';

const DashboardDocumentView = (props) => {

    const [hasReadPermissionUser, setHasReadPermissionUser] = useState('');
    const [hasAddPermissionUser, setHasAddPermissionUser] = useState('');
    const [hasEditPermissionUser, setHasEditPermissionUser] = useState('');
    const [hasDeletePermissionUser, setHasDeletePermissionUser] = useState('');

    const getAllPermission = () => {
        setHasReadPermissionUser(hasReadPermission(SecurityObjectName));
        setHasAddPermissionUser(hasAddPermission(SecurityObjectName));
        setHasEditPermissionUser(hasEditPermission(SecurityObjectName));
        setHasDeletePermissionUser(hasDeletePermission(SecurityObjectName));
    }

    const [loaderApi, setLoaderApi] = useState(false);

    const { register, handleSubmit, formState: { errors }, setValue } = useForm({});
    const [document, setDocument] = useState({});
    const [isFolder, setIsFolder] = useState('0');
    const [folderList, setFolderList] = useState([]);
    const [getFileSorted, setGetFileSorted] = useState([]);
    const [isEditing, setIsEditing] = useState(false);
    const [uploadingImage, setUploadingImage] = useState(false);
    const formRef = useRef();
    const [accordianStatus, setAccordianStatus] = useState('0');
    const [closePopup, setClosePopup] = useState(false);
    const [closePopupImgUpload, setClosePopupImgUpload] = useState(false);
    const [folderAddDetails, setFolderAddDetails] = useState('');
    const [fileAddDetails, setFileAddDetails] = useState('');
    const [folderAddNew, setFolderAddNew] = useState('');
    const [fileAddNew, setFileAddNew] = useState('');
    const ref = useRef();

    //reset input file value
    const resetFile = () => {
        ref.current.value = "";
    };

    //form submit
    const onSubmit = async (data, event) => {
        if (data.IsFolder == '0') {
            delete data.file;
            setUploadingImage(false);
            DocumentAdd(data);
        }
        if (data.file) {
            setUploadingImage(true);
            if (data.file[0] !== undefined && data.file[0].name !== null) {
                await HttpHelper.post("Document/UploadFileAsync", { 'Folder': 'temp', 'File': data.file[0] }, {
                    headers: {
                        'Content-Type': 'multipart/form-data; charset=utf-8',
                    }
                }).then((response) => {
                    if (response.status === 200) {
                        data.FileId = response.data[0].fileId;
                        delete data.file;
                        DocumentAdd(data, true, response.data)
                    } else {
                        console.log('error while uploading the image');
                    }
                }).catch((error) => {
                    console.log(error);
                })
            }
        }
    }

    //form submit add Folder
    const onSubmitFolderNew = async (e) => {
        var data = {};
        Object.assign(data, {
            IsFolder: '0',
            FolderName: folderAddNew,
            fileType: 'Folder',
            FolderId: e.documentId
        })
        await HttpHelper.post("Document", data).then((response) => {
            if (response.status === 200) {
            } else {
                console.log('error while uploading the image');
            }
            setFolderAddNew('');
            setClosePopup(false);
            props.showToast('success', 'Document Added Succesfully');
            GetDocuments();
            clearField();
        }).catch((error) => {
            console.log(error);
        })
    }

    //file submit add icon
    const onSubmitFileNew = async (e) => {
        var data = {};
        Object.assign(data, {
            IsFolder: '0',
            fileType: 'File',
            ParentId: e.documentId
        })
        if (fileAddNew !== undefined && fileAddNew.name !== null) {
            Object.assign(data, {
                fileType: '.' + fileAddNew.name.split('.')[1]
            })
            await HttpHelper.post("Document/UploadFileAsync", { 'Folder': 'temp', 'File': fileAddNew }, {
                headers: {
                    'Content-Type': 'multipart/form-data; charset=utf-8',
                }
            }).then(async (response) => {
                setFileAddNew('');
                Object.assign(data, {
                    FileId: response.data[0].fileId,
                    FileName: response.data[0].originalFileName,
                    FileType: response.data[0].fileType,
                })
                await HttpHelper.post("Document", data).then((response) => {
                    if (response.status === 200) {
                    } else {
                        console.log('error while uploading the image');
                    }
                    setFileAddNew('');
                    setFileAddDetails('');
                    setClosePopupImgUpload(false);
                    props.showToast('success', 'Document Added Succesfully');
                    GetDocuments();
                    clearField();
                }).catch((error) => {
                    console.log(error);
                })
                setFileAddNew('');
                resetFile();
                setFileAddNew('');
            }).catch((error) => {
                console.log(error);
            })
        }
    }

    //Document add funciton
    const DocumentAdd = async (data, withImg, dataImg) => {
        if (withImg === true) {
            if (data.ParentFolder == 'root') {
                data.ParentFolder = 0;
            }
            data = Object.assign(data, {
                IsFolder: parseInt(data.IsFolder),
                FileName: dataImg[0].originalFileName,
                fileType: isFolder == 0 ? 'Folder' : 'File',
                ParentId: data.ParentFolder,
                FileType: dataImg[0].fileType
            })
            await HttpHelper.post("Document", data).then((response) => {
                if (response.status === 200) {
                } else {
                    console.log('error while uploading the image');
                }
                GetDocuments();
                clearField();
            }).catch((error) => {
                DeleteUploadedFile(data.FileId)
            })
        } else {
            if (data.ParentFolder == '0') {
                data = Object.assign(data, {
                    FolderId: 0
                })
            } else {
                data = Object.assign(data, {
                    FolderId: data.ParentFolder
                })
            }
            data = Object.assign(data, {
                IsFolder: parseInt(data.IsFolder),
                FolderName: data.name,
                fileType: isFolder == 0 ? 'Folder' : 'File'
            })
            delete data.file;
            await HttpHelper.post("Document", data).then((response) => {
                if (response.status === 200) {
                } else {
                    console.log('error while uploading the image');
                }
                props.showToast('success', 'Document Added Succesfully');
                GetDocuments();
                clearField();
                setIsFolder('0');
            }).catch((error) => {
                console.log(error);
            })
        }
        clearField();
    }

    //get all documents (folder and files) by api
    const GetDocuments = async () => {
        setLoaderApi(true);
        await HttpHelper.get("Document").then((response) => {
            getFolderAndFiles(response.data.data);
            getAllPermission();
            setLoaderApi(false);
        }).catch((error) => {
            console.log(error);
        })
    }

    //filter all documents (folder and files) by api
    const getFolderAndFiles = (e) => {

        var folderId = [];
        var fileId = [];

        if (Array.isArray(e)) {

            //get all folder and files 
            var getAllFolder = e.filter((el) => {
                if (el.isFolder == 0) {
                    folderId.push(el.documentId)
                    Object.assign(el, {
                        children: []
                    })
                    return e;
                }
                else if (el.isFolder == 1) {
                    folderId.push(el.documentId)
                    Object.assign(el, {
                        children: []
                    })
                    return e;
                }
            });

            //get all folder 
            var getAllFolderList = e.filter((el) => {
                if (el.isFolder == 0) {
                    folderId.push(el.documentId)
                    Object.assign(el, {
                        children: []
                    })
                    return e;
                }
            });

            //get all folder in dropdown
            setFolderList(getAllFolderList);

            // all children blank array in every folder
            var getAllFolderList = e.filter((e) => {
                if (e.isFolder == 0) {
                    folderId.push(e.documentId)
                    Object.assign(e, {
                        children: []
                    })
                    return e;
                } else if (e.isFolder == 1) {
                    fileId.push(e.documentId)
                    Object.assign(e, {
                        children: []
                    })
                    return e;
                }
            });

            //get all Pushed data list
            var getAllPushedList = [];

            // add children data in array in every folder
            getAllFolder.map((e) => {
                if (e.documentId != null) {
                    if (e.isFolder == 0) {
                        getAllFolderList.map((el) => {
                            if (el.folderId == e.documentId) {
                                e.children.push(el);
                                getAllPushedList.push(el);
                                //getAllFolder.splice(getAllFolder.indexOf(el), 1);
                            }
                            else if (el.parentId == e.documentId) {
                                e.children.push(el);
                                getAllPushedList.push(el);
                                //   getAllFolder.splice(getAllFolder.indexOf(el), 1);
                            }
                        })
                    }
                }
            });

            getAllPushedList.map((e) => {
                getAllFolder.splice(getAllFolder.indexOf(e), 1);
            });

            // set folder for show data in list
            setGetFileSorted(getAllFolder);
            console.log(getAllFolder);

            //get all folder in dropdown
            var arrayB = [];
            const getFolderFinalList = getAllFolder.map((e) => {
                if (e.isFolder == 0) {
                    return addListFolder(e, arrayB);
                }
            })
            setFolderList(arrayB);
            console.log(getFolderFinalList, arrayB)

        }
    }

    //recursive for get folder lists
    const addListFolder = (e, arrayRe) => {
        if (e.isFolder == 0) {
            arrayRe.push(e);
            if (Array.isArray(e)) {
                if (e.isFolder == 0) {
                    arrayRe.push(e);
                }
                return e;
            } else if (e.children && e.children.length > 0) {
                e.children.map((el) => {
                    return addListFolder(el, arrayRe);
                })
            } else {
                return e;
            }
        }

    }

    //delete uploaded file if error occured
    const DeleteUploadedFile = async (fileId) => {
        await HttpHelper.delete("Setting/DeleteFileAsync?fileId=" + fileId).then((res) => {
            if (res.status === 200) {
                console.log('file deleted successfully', fileId);
            } else {
                console.log(res.data);
            }
            GetDocuments();
            props.showToast('success', 'Image deleted Succesfully');
        }).catch((error) => {
            console.log(error);
        })
    }

    //accordian status hanlde
    const accordianStatusHandle = (elem) => {

        if (elem === undefined) {
            if (accordianStatus === '0') {
                setAccordianStatus('1');
            } else {
                setAccordianStatus('0');
            }
        } else {
            setAccordianStatus(elem);
        }
    }

    //Delete documen by id
    const DeleteDocumentById = (id, fileId) => {
        swal("Are you sure, you want to delete this banner?", { buttons: ["Cancel", "Yes"] })
            .then(async (willDelete) => {
                if (willDelete) {
                    setIsEditing(false);
                    formRef.current.reset();
                    await HttpHelper.delete("Document/" + id).then((response) => {
                        if (response.status === 200) {
                            props.showToast('success', 'Document Deleted successfully');
                            GetDocuments()
                        } else {
                            props.showToast('error', response.data);
                            console.log(response.data);
                        }
                        if (fileId) {
                            DeleteUploadedFile(fileId);
                        }
                    }).catch((error) => {
                        props.showToast('error', 'some error occured');
                        console.log(error);
                    })
                }
            }
            );
    }

    //clear all field affter submit form
    const clearField = () => {
        setValue('name', '');
        setValue("IsFolder", '0');
        setIsFolder('0')
        setValue("file", '');
        setValue("ParentFolder", '');
    }

    //File upload validation
    function fileValidation(e) {
        var filePath = e.target.value;

        // Allowing file type
        var allowedExtensions =
            /(\.doc|\.docx|\.pdf|\.pdffill|\.xlsx|\.xlsm|\.xlsb|\.xltx)$/i;

        if (!allowedExtensions.exec(filePath)) {
            alert('Invalid file type');
            e.target.value = '';
            return false;
        }
        else {
            return e;
        }
    }

    //recursive for print data in grid
    const getArrayPrint = (e, space) => {
        if (Array.isArray(e)) {
            return e.map((el, index) => {
                var fileType = '';
                if (el.isFolder == 1) {
                    if (el.file) {
                        if (el.fileType) {
                            fileType = el.fileType;
                        }
                    }
                } else {
                    if (el.fileType) {
                        fileType = el.fileType;
                    }
                }
                return (
                    <>
                        <div className={`treeViewInnerCol`} >
                            <div className="treeViewInnerColDetails">
                                <div className="serialNo" style={{ marginLeft: space + 'px', textAlign: 'right' }} > {<FiCornerDownRight />}</div>
                                <b style={{ marginLeft: '5px' }}></b>
                                <div className="nameGrid"> {el.fileType == 'Folder' ? <><FcFolder size={15} /></> : ''} {el.fileType == 'Folder' ? el.folderName : el.fileName && el.fileName.split('.')[0]} </div>
                            </div>
                            <div className="treeViewInnerColDetailsType">
                                <div className="TypeMSWord">
                                    {fileType == '.doc' || fileType == '.docx' ? <a href={el.file.fileUrl} target="_Blank" download><AiOutlineFileWord /></a> : ''}
                                </div>
                                <div className="TypePdf">
                                    {fileType == '.pdf' ? <a href={el.file.fileUrl} target="_Blank" download><AiOutlineFilePdf /></a> : ''}
                                </div>
                                <div className="TypePdfFill">
                                    {fileType == '.pdffill' ? <a href={el.file.fileUrl} target="_Blank" download><BsFillFileEarmarkPdfFill /></a> : ''}
                                </div>
                                <div className="TypeMSExcel">
                                    {fileType == '.xlsx' || fileType == '.xlsm' || fileType == '.xlsb' || fileType == '.xltx' ? <a href={el.file.fileUrl} target="_Blank" download><AiOutlineFileExcel /></a> : ''}
                                </div>
                            </div>
                        </div>
                        {el.children && el.children.length > 0 ? getArrayPrint(el.children, space + 20) : ''}
                    </>
                )
            })
        }
    }

    const getAddFolderDetails = (e) => {
        setFolderAddDetails('');
        setClosePopup(true);
        setFolderAddDetails([e]);
    }

    const getAddFileDetails = (e) => {
        setFileAddDetails('');
        setClosePopupImgUpload(true);
        setFileAddDetails([e]);
    }

    useEffect(() => {
        GetDocuments();
    }, []);

    return (
        <>
            <DashboardWrapper>
                <ToastContainer />
                <div className="DashboardWrapperChild">
                    <Sidebar />
                    <div className="contentWrapper">
                        <HeaderDashboard title="Documents Views" />
                        <div className="container-fluid mt-80 p-0">
                            <div className="row">
                                <div className="col-md-12 mb-2">
                                </div>


                                {hasAddPermissionUser == true && loaderApi == false ? <div className="col-md-12">
                                    <div className="col-md-12 mb-2">
                                        <div className="cardBox cardTableWrapperDashboard">
                                            <div className="treeViewGrid">
                                                <div className="treeViewInnerCol treeViewHeader">
                                                    <div className="treeViewHeaderInnerColDetails">
                                                        <div className="nameGrid"> Name </div>
                                                    </div>
                                                    <div className="treeViewHeaderInnerColDetailsType">
                                                        <div className="TypeMSWord"> MS Word </div>
                                                        <div className="TypePdf"> PDF </div>
                                                        <div className="TypePdfFill"> PDF Fillable	 </div>
                                                        <div className="TypeMSExcel"> MS Excel </div>
                                                    </div>
                                                </div>
                                                {getFileSorted !== undefined && getFileSorted.length > 0 ? getFileSorted.map((e, i) => {
                                                    var fileType = '';
                                                    if (e.isFolder == 1) {
                                                        if (e.file) {
                                                            if (e.fileType) {
                                                                fileType = e.fileType;
                                                            }
                                                        }
                                                    }
                                                    return <>
                                                        <div className="treeViewInnerCol">
                                                            <div className="treeViewInnerColDetails">
                                                                <div className="nameGrid"> {e.fileType == 'Folder' ? <><FcFolder size={20} /></> : ''} {e.fileType == 'Folder' ? e.folderName : e.fileName && e.fileName.split('.')[0]} </div>
                                                            </div>
                                                            <div className="treeViewInnerColDetailsType">
                                                                <div className="TypeMSWord">
                                                                    {fileType == '.doc' || fileType == '.docx' ? <a href={e.file.fileUrl} target="_Blank" download><AiOutlineFileWord /></a> : ''}
                                                                </div>
                                                                <div className="TypePdf">
                                                                    {fileType == '.pdf' ? <a href={e.file.fileUrl} target="_Blank" download><AiOutlineFilePdf /></a> : ''}
                                                                </div>
                                                                <div className="TypePdfFill">
                                                                    {fileType == '.pdffill' ? <a href={e.file.fileUrl} target="_Blank" download><BsFillFileEarmarkPdfFill /></a> : ''}
                                                                </div>
                                                                <div className="TypeMSExcel">
                                                                    {fileType == '.xlsx' || fileType == '.xlsm' || fileType == '.xlsb' || fileType == '.xltx' ? <a href={e.file.fileUrl} target="_Blank" download><AiOutlineFileExcel /></a> : ''}
                                                                </div>
                                                            </div>
                                                        </div>
                                                        {e.children && e.children.map((el) => {
                                                            var fileTypeChild = '';
                                                            if (el.isFolder == 1) {
                                                                if (el.file) {
                                                                    if (el.fileType) {
                                                                        fileTypeChild = el.fileType;
                                                                    }
                                                                }
                                                            }
                                                            return <>
                                                                <div className="treeViewInnerCol">
                                                                    <div className="treeViewInnerColDetails">
                                                                        <div className="serialNo" style={{ marginLeft: '20px', textAlign: 'right' }} > {<FiCornerDownRight />}</div>
                                                                        <b style={{ marginLeft: '5px' }}></b>
                                                                        <div className="nameGrid"> {el.fileType == 'Folder' ? <><FcFolder size={15} /></> : ''} {el.fileType == 'Folder' ? el.folderName : el.fileName && el.fileName.split('.')[0]}</div>
                                                                    </div>
                                                                    <div className="treeViewInnerColDetailsType">
                                                                        <div className="TypeMSWord">
                                                                            {fileTypeChild == '.doc' || fileTypeChild == '.docx' ? <AiOutlineFileWord /> : ''}
                                                                        </div>
                                                                        <div className="TypePdf">
                                                                            {fileTypeChild == '.pdf' ? <AiOutlineFilePdf /> : ''}
                                                                        </div>
                                                                        <div className="TypePdfFill">
                                                                            {fileTypeChild == '.pdffill' ? <BsFillFileEarmarkPdfFill /> : ''}
                                                                        </div>
                                                                        <div className="TypeMSExcel">
                                                                            {fileTypeChild == '.xlsx' || fileTypeChild == '.xlsm' || fileTypeChild == '.xlsb' || fileTypeChild == '.xltx' ? <AiOutlineFileExcel /> : ''}
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                {el.children && el.children.length > 0 ? getArrayPrint(el.children, 30) : ''}
                                                            </>
                                                        })}
                                                    </>
                                                }) : ''}
                                            </div>
                                        </div>
                                        <table className="table tableCustomized d-none">
                                            <thead>
                                                <tr>
                                                    <th>
                                                        #
                                                    </th>
                                                    <th>
                                                        Is Folder
                                                    </th>
                                                    <th>
                                                        Folder Name
                                                    </th>
                                                    <th>
                                                        File Type
                                                    </th>
                                                    <th>
                                                        File Name
                                                    </th>
                                                    <th>
                                                        Action
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    document !== undefined && document.length > 0 ? document.map((document, index) => {
                                                        return (<>
                                                            <tr key={index}>
                                                                <td>
                                                                    {index + 1}
                                                                </td>
                                                                <td>
                                                                    {document.isFolder == 0 ? 'Yes' : 'No'}
                                                                </td>
                                                                <td>
                                                                    {document.folderName}
                                                                </td>
                                                                <td>
                                                                    {document.fileType}
                                                                </td>
                                                                <td>
                                                                    {document.fileName}
                                                                </td>
                                                                <td>
                                                                    {/*<CiEdit onClick={() => { updateSetting(document.documentId) }} />*/}
                                                                    {/*&nbsp;*/}
                                                                    <AiOutlineDelete onClick={() => { DeleteDocumentById(document.documentId, document.fileId) }} />
                                                                </td>
                                                            </tr>
                                                        </>)
                                                    })
                                                        : <tr><td colSpan={5}> No Document data found!!!</td></tr>
                                                }

                                            </tbody>
                                        </table>
                                    </div>
                                </div> : loaderApi == false && hasAddPermissionUser == false ? <div className="NoPermission">Don't Have Permisiion</div> : <div className="loaderApi">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="38" height="38" viewBox="0 0 38 38" stroke="#000">
                                        <g fill="none" fill-rule="evenodd">
                                            <g transform="translate(1 1)" stroke-width="2">
                                                <circle stroke-opacity=".5" cx="18" cy="18" r="18" />
                                                <path d="M36 18c0-9.94-8.06-18-18-18">
                                                    <animateTransform attributeName="transform" type="rotate" from="0 18 18" to="360 18 18" dur="1s" repeatCount="indefinite" />
                                                </path>
                                            </g>
                                        </g>
                                    </svg>
                                </div>}



                                {/*{hasReadPermissionUser == true ? <div className="col-md-12">*/}
                                {/*    <div className="col-md-12 mb-2">*/}
                                {/*        <div className="cardBox cardTableWrapperDashboard">*/}
                                {/*            <div className="treeViewGrid">*/}
                                {/*                <div className="treeViewInnerCol treeViewHeader">*/}
                                {/*                    <div className="treeViewHeaderInnerColDetails">*/}
                                {/*                        <div className="nameGrid"> Name </div>*/}
                                {/*                    </div>*/}
                                {/*                    <div className="treeViewHeaderInnerColDetailsType">*/}
                                {/*                        <div className="TypeMSWord"> MS Word </div>*/}
                                {/*                        <div className="TypePdf"> PDF </div>*/}
                                {/*                        <div className="TypePdfFill"> PDF Fillable	 </div>*/}
                                {/*                        <div className="TypeMSExcel"> MS Excel </div>*/}
                                {/*                    </div>*/}
                                {/*                </div>*/}
                                {/*                {getFileSorted !== undefined && getFileSorted.length > 0 ? getFileSorted.map((e, i) => {*/}
                                {/*                    var fileType = '';*/}
                                {/*                    if (e.isFolder == 1) {*/}
                                {/*                        if (e.file) {*/}
                                {/*                            if (e.fileType) {*/}
                                {/*                                fileType = e.fileType;*/}
                                {/*                            }*/}
                                {/*                        }*/}
                                {/*                    }*/}
                                {/*                    return <>*/}
                                {/*                        <div className="treeViewInnerCol">*/}
                                {/*                            <div className="treeViewInnerColDetails">*/}
                                {/*                                <div className="nameGrid"> {e.fileType == 'Folder' ? <><FcFolder size={20} /></> : ''} {e.fileType == 'Folder' ? e.folderName : e.fileName && e.fileName.split('.')[0]} </div>*/}
                                {/*                            </div>*/}
                                {/*                            <div className="treeViewInnerColDetailsType">*/}
                                {/*                                <div className="TypeMSWord">*/}
                                {/*                                    {fileType == '.doc' || fileType == '.docx' ? <a href={e.file.fileUrl} target="_Blank" download><AiOutlineFileWord /></a> : ''}*/}
                                {/*                                </div>*/}
                                {/*                                <div className="TypePdf">*/}
                                {/*                                    {fileType == '.pdf' ? <a href={e.file.fileUrl} target="_Blank" download><AiOutlineFilePdf /></a> : ''}*/}
                                {/*                                </div>*/}
                                {/*                                <div className="TypePdfFill">*/}
                                {/*                                    {fileType == '.pdffill' ? <a href={e.file.fileUrl} target="_Blank" download><BsFillFileEarmarkPdfFill /></a> : ''}*/}
                                {/*                                </div>*/}
                                {/*                                <div className="TypeMSExcel">*/}
                                {/*                                    {fileType == '.xlsx' || fileType == '.xlsm' || fileType == '.xlsb' || fileType == '.xltx' ? <a href={e.file.fileUrl} target="_Blank" download><AiOutlineFileExcel /></a> : ''}*/}
                                {/*                                </div>*/}
                                {/*                            </div>*/}
                                {/*                        </div>*/}
                                {/*                        {e.children && e.children.map((el) => {*/}
                                {/*                            var fileTypeChild = '';*/}
                                {/*                            if (el.isFolder == 1) {*/}
                                {/*                                if (el.file) {*/}
                                {/*                                    if (el.fileType) {*/}
                                {/*                                        fileTypeChild = el.fileType;*/}
                                {/*                                    }*/}
                                {/*                                }*/}
                                {/*                            }*/}
                                {/*                            return <>*/}
                                {/*                                <div className="treeViewInnerCol">*/}
                                {/*                                    <div className="treeViewInnerColDetails">*/}
                                {/*                                        <div className="serialNo" style={{ marginLeft: '20px', textAlign: 'right' }} > {<FiCornerDownRight />}</div>*/}
                                {/*                                        <b style={{ marginLeft: '5px' }}></b>*/}
                                {/*                                        <div className="nameGrid"> {el.fileType == 'Folder' ? <><FcFolder size={15} /></> : ''} {el.fileType == 'Folder' ? el.folderName : el.fileName && el.fileName.split('.')[0]}</div>*/}
                                {/*                                    </div>*/}
                                {/*                                    <div className="treeViewInnerColDetailsType">*/}
                                {/*                                        <div className="TypeMSWord">*/}
                                {/*                                            {fileTypeChild == '.doc' || fileTypeChild == '.docx' ? <AiOutlineFileWord /> : ''}*/}
                                {/*                                        </div>*/}
                                {/*                                        <div className="TypePdf">*/}
                                {/*                                            {fileTypeChild == '.pdf' ? <AiOutlineFilePdf /> : ''}*/}
                                {/*                                        </div>*/}
                                {/*                                        <div className="TypePdfFill">*/}
                                {/*                                            {fileTypeChild == '.pdffill' ? <BsFillFileEarmarkPdfFill /> : ''}*/}
                                {/*                                        </div>*/}
                                {/*                                        <div className="TypeMSExcel">*/}
                                {/*                                            {fileTypeChild == '.xlsx' || fileTypeChild == '.xlsm' || fileTypeChild == '.xlsb' || fileTypeChild == '.xltx' ? <AiOutlineFileExcel /> : ''}*/}
                                {/*                                        </div>*/}
                                {/*                                    </div>*/}
                                {/*                                </div>*/}
                                {/*                                {el.children && el.children.length > 0 ? getArrayPrint(el.children, 30) : ''}*/}
                                {/*                            </>*/}
                                {/*                        })}*/}
                                {/*                    </>*/}
                                {/*                }) : ''}*/}
                                {/*            </div>*/}
                                {/*        </div>*/}
                                {/*        <table className="table tableCustomized d-none">*/}
                                {/*            <thead>*/}
                                {/*                <tr>*/}
                                {/*                    <th>*/}
                                {/*                        #*/}
                                {/*                    </th>*/}
                                {/*                    <th>*/}
                                {/*                        Is Folder*/}
                                {/*                    </th>*/}
                                {/*                    <th>*/}
                                {/*                        Folder Name*/}
                                {/*                    </th>*/}
                                {/*                    <th>*/}
                                {/*                        File Type*/}
                                {/*                    </th>*/}
                                {/*                    <th>*/}
                                {/*                        File Name*/}
                                {/*                    </th>*/}
                                {/*                    <th>*/}
                                {/*                        Action*/}
                                {/*                    </th>*/}
                                {/*                </tr>*/}
                                {/*            </thead>*/}
                                {/*            <tbody>*/}
                                {/*                {*/}
                                {/*                    document !== undefined && document.length > 0 ? document.map((document, index) => {*/}
                                {/*                        return (<>*/}
                                {/*                            <tr key={index}>*/}
                                {/*                                <td>*/}
                                {/*                                    {index + 1}*/}
                                {/*                                </td>*/}
                                {/*                                <td>*/}
                                {/*                                    {document.isFolder == 0 ? 'Yes' : 'No'}*/}
                                {/*                                </td>*/}
                                {/*                                <td>*/}
                                {/*                                    {document.folderName}*/}
                                {/*                                </td>*/}
                                {/*                                <td>*/}
                                {/*                                    {document.fileType}*/}
                                {/*                                </td>*/}
                                {/*                                <td>*/}
                                {/*                                    {document.fileName}*/}
                                {/*                                </td>*/}
                                {/*                                <td>*/}
                                {/*                                    */}{/*<CiEdit onClick={() => { updateSetting(document.documentId) }} />*/}
                                {/*                                    */}{/*&nbsp;*/}
                                {/*                                    <AiOutlineDelete onClick={() => { DeleteDocumentById(document.documentId, document.fileId) }} />*/}
                                {/*                                </td>*/}
                                {/*                            </tr>*/}
                                {/*                        </>)*/}
                                {/*                    })*/}
                                {/*                        : <tr><td colSpan={5}> No Document data found!!!</td></tr>*/}
                                {/*                }*/}

                                {/*            </tbody>*/}
                                {/*        </table>*/}
                                {/*    </div>*/}
                                {/*</div> : <div className="NoPermission">Don't Have Permisiion</div>}*/}
                            </div>
                        </div>
                    </div>
                </div>
            </DashboardWrapper>
        </>
    )
}

export default DashboardDocumentView;